

// import React, { useState, useEffect, useRef } from 'react';
// import QRCode from 'qrcode';


// const StudentCertificatePage = () => {
//   const [students, setStudents] = useState([]);
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [certificatePreview, setCertificatePreview] = useState(null);
//   const [generatingCertificate, setGeneratingCertificate] = useState(false);
//   const certificateRef = useRef();

//   useEffect(() => {
//     const fetchStudents = async () => {
//       try {
//         const response = await fetch('/api/new/registrations');
//         const data = await response.json();
//         setStudents(data);
//         setLoading(false);
//       } catch (err) {
//         setError('Failed to fetch student data');
//         setLoading(false);
//       }
//     };
//     fetchStudents();
//   }, []);

//   const loadPDFLib = async () => {
//     if (window.PDFLib) {
//       return window.PDFLib;
//     }
    
//     try {
//       // Try loading from CDN
//       return new Promise((resolve, reject) => {
//         const script = document.createElement('script');
//         script.src = 'https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js';
//         script.onload = () => {
//           if (window.PDFLib) {
//             resolve(window.PDFLib);
//           } else {
//             reject(new Error('PDF-lib failed to load'));
//           }
//         };
//         script.onerror = () => reject(new Error('Failed to load PDF-lib script'));
//         document.head.appendChild(script);
        
//         // Timeout after 10 seconds
//         setTimeout(() => reject(new Error('PDF-lib loading timeout')), 10000);
//       });
//     } catch (error) {
//       console.error('Error loading PDF-lib:', error);
//       throw error;
//     }
//   };

//   const generateCertificate = async (student) => {
//     setGeneratingCertificate(true);
//     try {
//       // Load PDF-lib
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       // Check if template exists
//       const response = await fetch('./cert5.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found. Please ensure cert5.pdf is in the public folder.');
//       }
      
//       // Fetch the existing certificate template
//       const existingPdfBytes = await response.arrayBuffer();
      
//       // Load the existing PDF
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();
//       const qrText = `http://localhost:5176/student/${student.regid}`;
// const qrDataUrl = await QRCode.toDataURL(qrText);

// // Embed QR code image into PDF
// const qrImageBytes = await fetch(qrDataUrl).then(res => res.arrayBuffer());
// const qrImage = await pdfDoc.embedPng(qrImageBytes);
// const qrDims = qrImage.scale(0.7);

// // Draw the QR code on the page (adjust position as needed)
// firstPage.drawImage(qrImage, {
//   x: width - 120,
//   y: 120,
//   width: qrDims.width,
//   height: qrDims.height,
// });
      

//       // Add text to the certificate
//       // Student Name
//       firstPage.drawText(`${student.fName} ${student.lName}`, {
//         x: width / 2 - 100, // Adjust position as needed
//         y: height - 300, // Adjust position as needed
//         size: 24,
//         color: rgb(0, 0, 0),
//       });

//       // Father's Name (if available)
//       if (student.fatherName) {
//         firstPage.drawText(`S/O ${student.fatherName}`, {
//           x: width / 2 - 80,
//           y: height - 340,
//           size: 16,
//           color: rgb(0, 0, 0),
//         });
//       }

//       // Course Name
//       firstPage.drawText(student.courseName || 'Course Name', {
//         x: width / 2 - 100,
//         y: height - 380,
//         size: 18,
//         color: rgb(0, 0, 0),
//       });

//       // Software Covered (if available)
//       if (student.softwareCovered) {
//         firstPage.drawText(`Software: ${student.softwareCovered}`, {
//           x: width / 2 - 120,
//           y: height - 420,
//           size: 14,
//           color: rgb(0, 0, 0),
//         });
//       }

//       // Duration (if available)
//       if (student.duration) {
//         firstPage.drawText(`Duration: ${student.duration}`, {
//           x: width / 2 - 80,
//           y: height - 450,
//           size: 14,
//           color: rgb(0, 0, 0),
//         });
//       }

//       // Grade
//       firstPage.drawText(`Grade: ${student.Grade}`, {
//         x: width / 2 - 60,
//         y: height - 480,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });

//       // Registration ID
//       firstPage.drawText(`Registration ID: ${student.regid}`, {
//         x: width / 2 - 100,
//         y: height - 510,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       // Date
//       const currentDate = new Date().toLocaleDateString();
//       firstPage.drawText(`Date: ${currentDate}`, {
//         x: width - 200,
//         y: 100,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       // Generate PDF bytes
//       const pdfBytes = await pdfDoc.save();
      
//       // Create blob URL for preview
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       setCertificatePreview(url);
      
//     } catch (error) {
//       console.error('Error generating certificate:', error);
//       alert('Error generating certificate. Please try again.');
//     } finally {
//       setGeneratingCertificate(false);
//     }
//   };

//   const downloadCertificate = async (student) => {
//     try {
//       // Load PDF-lib
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       // Check if template exists
//       const response = await fetch('./cert5.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found. Please ensure cert5.pdf is in the public folder.');
//       }
      
//       // Fetch the existing certificate template
//       const existingPdfBytes = await response.arrayBuffer();
      
//       // Load the existing PDF
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();

//       // Add text to the certificate (same as preview)
//       firstPage.drawText(`${student.fName} ${student.lName}`, {
//         x: width / 2 - 100,
//         y: height - 300,
//         size: 24,
//         color: rgb(0, 0, 0),
//       });

//       if (student.fatherName) {
//         firstPage.drawText(`S/O ${student.fatherName}`, {
//           x: width / 2 - 80,
//           y: height - 340,
//           size: 16,
//           color: rgb(0, 0, 0),
//         });
//       }

//       firstPage.drawText(student.courseName || 'Course Name', {
//         x: width / 2 - 100,
//         y: height - 380,
//         size: 18,
//         color: rgb(0, 0, 0),
//       });

//       if (student.softwareCovered) {
//         firstPage.drawText(`Software: ${student.softwareCovered}`, {
//           x: width / 2 - 120,
//           y: height - 420,
//           size: 14,
//           color: rgb(0, 0, 0),
//         });
//       }

//       if (student.duration) {
//         firstPage.drawText(`Duration: ${student.duration}`, {
//           x: width / 2 - 80,
//           y: height - 450,
//           size: 14,
//           color: rgb(0, 0, 0),
//         });
//       }

//       firstPage.drawText(`Grade: ${student.Grade}`, {
//         x: width / 2 - 60,
//         y: height - 480,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Registration ID: ${student.regid}`, {
//         x: width / 2 - 100,
//         y: height - 510,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const currentDate = new Date().toLocaleDateString();
//       firstPage.drawText(`Date: ${currentDate}`, {
//         x: width - 200,
//         y: 100,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       // Generate PDF bytes
//       const pdfBytes = await pdfDoc.save();
      
//       // Create download link
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `Certificate_${student.fName}_${student.lName}_${student.regid}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
      
//     } catch (error) {
//       console.error('Error downloading certificate:', error);
//       alert('Error downloading certificate. Please try again.');
//     }
//   };

//   if (error) {
//     return (
//       <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
//         <div className="alert alert-danger" role="alert">
//           <h4 className="alert-heading">Error!</h4>
//           <p>{error}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '2rem' }}>
//       <div className="row">
//         <div className="col-12">
//           <h1 className="mb-4 text-dark fw-bold">Student Certificates</h1>
//         </div>
//       </div>

//       <div className="row">
//         {/* Student List */}
//         <div className="col-lg-4 col-md-6 mb-4">
//           <div className="card shadow-sm">
//             <div className="card-header">
//               <h5 className="card-title mb-0">
//                 Students List
//               </h5>
//             </div>
//             <div className="card-body" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//               {students.map((student) => (
//                 <div
//                   key={student._id}
//                   className={`card mb-3 cursor-pointer ${
//                     selectedStudent?._id === student._id
//                       ? 'border-primary bg-light'
//                       : ''
//                   }`}
//                   onClick={() => setSelectedStudent(student)}
//                   style={{ cursor: 'pointer' }}
//                 >
//                   <div className="card-body p-3">
//                     <div className="d-flex justify-content-between align-items-start">
//                       <div>
//                         <h6 className="card-title mb-1">{student.fName} {student.lName}</h6>
//                         <p className="card-text text-muted mb-1">ID: {student.regid}</p>
//                         <p className="card-text text-muted mb-0">{student.courseName}</p>
//                       </div>
//                       <span className={`badge ${
//                         student.Grade === 'Excellent' ? 'bg-success' :
//                         student.Grade === 'Good' ? 'bg-primary' :
//                         'bg-warning text-dark'
//                       }`}>
//                         {student.Grade}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Student Details and Certificate */}
//         <div className="col-lg-8 col-md-6">
//           {selectedStudent ? (
//             <div className="row">
//               {/* Student Details */}
//               <div className="col-12 mb-4">
//                 <div className="card shadow-sm">
//                   <div className="card-header">
//                     <h5 className="card-title mb-0">Student Details</h5>
//                   </div>
//                   <div className="card-body">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <p><strong>Name:</strong> {selectedStudent.fName} {selectedStudent.lName}</p>
//                         <p><strong>Registration ID:</strong> {selectedStudent.regid}</p>
//                         <p><strong>Course:</strong> {selectedStudent.courseName}</p>
//                         <p><strong>Grade:</strong> {selectedStudent.Grade}</p>
//                       </div>
//                       <div className="col-md-6">
//                         {selectedStudent.fatherName && (
//                           <p><strong>Father's Name:</strong> {selectedStudent.fatherName}</p>
//                         )}
//                         {selectedStudent.softwareCovered && (
//                           <p><strong>Software Covered:</strong> {selectedStudent.softwareCovered}</p>
//                         )}
//                         {selectedStudent.duration && (
//                           <p><strong>Duration:</strong> {selectedStudent.duration}</p>
//                         )}
//                       </div>
//                     </div>
                    
//                     {/* Certificate Actions */}
//                     <div className="mt-3">
//                       <button
//                         className="btn btn-primary me-3"
//                         onClick={() => generateCertificate(selectedStudent)}
//                         disabled={generatingCertificate}
//                       >
//                         {generatingCertificate ? 'Generating Preview...' : 'Preview Certificate'}
//                       </button>
//                       <button
//                         className="btn btn-success"
//                         onClick={() => downloadCertificate(selectedStudent)}
//                       >
//                         Download Certificate
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Certificate Preview */}
//               {certificatePreview && (
//                 <div className="col-12">
//                   <div className="card shadow-sm">
//                     <div className="card-header d-flex justify-content-between align-items-center">
//                       <h5 className="card-title mb-0">Certificate Preview</h5>
//                       <button
//                         className="btn btn-sm btn-outline-secondary"
//                         onClick={() => setCertificatePreview(null)}
//                       >
//                         Close Preview
//                       </button>
//                     </div>
//                     <div className="card-body">
//                       <div className="d-flex justify-content-center">
//                         <iframe
//                           src={certificatePreview}
//                           width="100%"
//                           height="600px"
//                           style={{ border: '1px solid #dee2e6', borderRadius: '0.375rem' }}
//                           title="Certificate Preview"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="card shadow-sm">
//               <div className="card-body text-center py-5">
//                 <h5 className="text-muted">Select a student to view details and generate certificate</h5>
//                 <p className="text-muted">Click on any student from the list to get started</p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentCertificatePage;

// import React, { useState, useEffect } from 'react';

// const StudentCertificatePage = () => {
//   const [students, setStudents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [certificatePreview, setCertificatePreview] = useState(null);
//   const [generatingCertificate, setGeneratingCertificate] = useState(false);
  
//   // Modal states
//   const [showModal, setShowModal] = useState(false);
//   const [currentStudent, setCurrentStudent] = useState(null);
//   const [modalData, setModalData] = useState({
//     certificateGrade: '',
//     awardedDate: ''
//   });
//   const [actionType, setActionType] = useState(''); // 'preview' or 'download'

//   useEffect(() => {
//     fetchStudents();
//   }, []);

//   const fetchStudents = async () => {
//     try {
//       const response = await fetch('/api/new/registrations');
//       const data = await response.json();
//       setStudents(data);
//       setLoading(false);
//     } catch (err) {
//       setError('Failed to fetch student data');
//       setLoading(false);
//     }
//   };

//   const checkCertificateDetails = (student, action) => {
//     if (!student.awardedDate || !student.certificateGrade) {
//       // Show modal to enter details
//       setCurrentStudent(student);
//       setActionType(action);
//       setModalData({
//         certificateGrade: student.certificateGrade || '',
//         awardedDate: student.awardedDate ? new Date(student.awardedDate).toISOString().split('T')[0] : ''
//       });
//       setShowModal(true);
//     } else {
//       // Proceed with action
//       if (action === 'preview') {
//         generateCertificate(student);
//       } else if (action === 'download') {
//         downloadCertificate(student);
//       }
//     }
//   };

//   const handleModalSubmit = async () => {
//     try {
//       if (!modalData.certificateGrade || !modalData.awardedDate) {
//         alert('Please fill in both fields');
//         return;
//       }

//       // Update certificate details in database
//       const response = await fetch(`/api/student/certificate/${currentStudent.regid}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           certificateGrade: modalData.certificateGrade,
//           awardedDate: modalData.awardedDate
//         })
//       });

//       if (!response.ok) {
//         throw new Error('Failed to update certificate details');
//       }

//       const result = await response.json();
      
//       // Update the student in local state
//       setStudents(prev => prev.map(student => 
//         student.regid === currentStudent.regid 
//           ? { ...student, certificateGrade: modalData.certificateGrade, awardedDate: modalData.awardedDate }
//           : student
//       ));

//       // Close modal
//       setShowModal(false);
      
//       // Proceed with the action
//       const updatedStudent = {
//         ...currentStudent,
//         certificateGrade: modalData.certificateGrade,
//         awardedDate: modalData.awardedDate
//       };

//       if (actionType === 'preview') {
//         generateCertificate(updatedStudent);
//       } else if (actionType === 'download') {
//         downloadCertificate(updatedStudent);
//       }

//     } catch (error) {
//       console.error('Error updating certificate details:', error);
//       alert('Error updating certificate details. Please try again.');
//     }
//   };

//   const loadPDFLib = async () => {
//     if (window.PDFLib) {
//       return window.PDFLib;
//     }
    
//     return new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js';
//       script.onload = () => {
//         if (window.PDFLib) {
//           resolve(window.PDFLib);
//         } else {
//           reject(new Error('PDF-lib failed to load'));
//         }
//       };
//       script.onerror = () => reject(new Error('Failed to load PDF-lib script'));
//       document.head.appendChild(script);
      
//       setTimeout(() => reject(new Error('PDF-lib loading timeout')), 10000);
//     });
//   };

//   const generateCertificate = async (student) => {
//     setGeneratingCertificate(true);
//     try {
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       const response = await fetch('./cert5.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found');
//       }
      
//       const existingPdfBytes = await response.arrayBuffer();
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();

//       // Add text to certificate
//       firstPage.drawText(`${student.fName} ${student.lName}`, {
//         x: width / 2 - 100,
//         y: height - 300,
//         size: 24,
//         color: rgb(0, 0, 0),
//       });

//       if (student.guardianName) {
//         firstPage.drawText(`S/O ${student.guardianName}`, {
//           x: width / 2 - 80,
//           y: height - 340,
//           size: 16,
//           color: rgb(0, 0, 0),
//         });
//       }

//       firstPage.drawText(student.courseName || 'Course Name', {
//         x: width / 2 - 100,
//         y: height - 380,
//         size: 18,
//         color: rgb(0, 0, 0),
//       });
//  firstPage.drawText(`Software covred: ${student.SubjectName}`, {
//         x: width / 2 - 80,
//         y: height - 440,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });
//       // Use certificateGrade instead of Grade
//       firstPage.drawText(`Grade: ${student.certificateGrade}`, {
//         x: width / 2 - 60,
//         y: height - 480,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Registration ID: ${student.regid}`, {
//         x: width / 2 - 100,
//         y: height - 510,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       // Use awardedDate
//       const awardedDate = new Date(student.awardedDate).toLocaleDateString();
//       firstPage.drawText(`Date: ${awardedDate}`, {
//         x: width - 200,
//         y: 100,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const pdfBytes = await pdfDoc.save();
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       setCertificatePreview(url);
      
//     } catch (error) {
//       console.error('Error generating certificate:', error);
//       alert('Error generating certificate. Please try again.');
//     } finally {
//       setGeneratingCertificate(false);
//     }
//   };

//   const downloadCertificate = async (student) => {
//     try {
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       const response = await fetch('./cert5.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found');
//       }
      
//       const existingPdfBytes = await response.arrayBuffer();
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();

//       // Same certificate generation logic as preview
//       firstPage.drawText(`${student.fName} ${student.lName}`, {
//         x: width / 2 - 100,
//         y: height - 300,
//         size: 24,
//         color: rgb(0, 0, 0),
//       });

//       if (student.guardianName) {
//         firstPage.drawText(`S/O ${student.guardianName}`, {
//           x: width / 2 - 80,
//           y: height - 340,
//           size: 16,
//           color: rgb(0, 0, 0),
//         });
//       }

//       firstPage.drawText(student.courseName || 'Course Name', {
//         x: width / 2 - 100,
//         y: height - 380,
//         size: 18,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Grade: ${student.certificateGrade}`, {
//         x: width / 2 - 60,
//         y: height - 480,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Registration ID: ${student.regid}`, {
//         x: width / 2 - 100,
//         y: height - 510,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const awardedDate = new Date(student.awardedDate).toLocaleDateString();
//       firstPage.drawText(`Date: ${awardedDate}`, {
//         x: width - 200,
//         y: 100,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const pdfBytes = await pdfDoc.save();
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `Certificate_${student.fName}_${student.lName}_${student.regid}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
      
//     } catch (error) {
//       console.error('Error downloading certificate:', error);
//       alert('Error downloading certificate. Please try again.');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
//         <div className="alert alert-danger">
//           <h4>Error!</h4>
//           <p>{error}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '2rem' }}>
//       <div className="row">
//         <div className="col-12">
//           <h1 className="mb-4 text-dark fw-bold">Student Certificates</h1>
//         </div>
//       </div>

//       {/* Students Table */}
//       <div className="row">
//         <div className="col-12">
//           <div className="card shadow-sm">
//             <div className="card-header">
//               <h5 className="card-title mb-0">Students List</h5>
//             </div>
//             <div className="card-body">
//               <div className="table-responsive">
//                 <table className="table table-hover">
//                   <thead className="table-light">
//                     <tr>
//                       <th>Reg ID</th>
//                       <th>Name</th>
//                       <th>Course</th>
//                       <th>Grade</th>
//                       <th>Certificate Grade</th>
//                       <th>Awarded Date</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {students.map((student) => (
//                       <tr key={student._id}>
//                         <td>{student.regid}</td>
//                         <td>{student.fName} {student.lName}</td>
//                         <td>{student.courseName}</td>
//                         <td>
//                           <span className={`badge ${
//                             student.Grade === 'Excellent' ? 'bg-success' :
//                             student.Grade === 'Good' ? 'bg-primary' :
//                             'bg-warning text-dark'
//                           }`}>
//                             {student.Grade}
//                           </span>
//                         </td>
//                         <td>
//                           {student.certificateGrade ? (
//                             <span className="badge bg-info">{student.certificateGrade}</span>
//                           ) : (
//                             <span className="badge bg-secondary">Not Set</span>
//                           )}
//                         </td>
//                         <td>
//                           {student.awardedDate ? 
//                             new Date(student.awardedDate).toLocaleDateString() : 
//                             <span className="text-muted">Not Set</span>
//                           }
//                         </td>
//                         <td>
//                           <button
//                             className="btn btn-sm btn-outline-primary me-2"
//                             onClick={() => checkCertificateDetails(student, 'preview')}
//                             disabled={generatingCertificate}
//                           >
//                             {generatingCertificate ? 'Loading...' : 'Preview'}
//                           </button>
//                           <button
//                             className="btn btn-sm btn-success"
//                             onClick={() => checkCertificateDetails(student, 'download')}
//                           >
//                             Download
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Certificate Preview */}
//       {certificatePreview && (
//         <div className="row mt-4">
//           <div className="col-12">
//             <div className="card shadow-sm">
//               <div className="card-header d-flex justify-content-between align-items-center">
//                 <h5 className="card-title mb-0">Certificate Preview</h5>
//                 <button
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={() => setCertificatePreview(null)}
//                 >
//                   Close Preview
//                 </button>
//               </div>
//               <div className="card-body">
//                 <iframe
//                   src={certificatePreview}
//                   width="100%"
//                   height="600px"
//                   style={{ border: '1px solid #dee2e6', borderRadius: '0.375rem' }}
//                   title="Certificate Preview"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modal for Certificate Details */}
//       {showModal && (
//         <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Certificate Details Required</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <p className="mb-3">
//                   Please enter the certificate details for <strong>{currentStudent?.fName} {currentStudent?.lName}</strong>:
//                 </p>
//                 <div>
//                   <div className="mb-3">
//                     <label htmlFor="certificateGrade" className="form-label">Certificate Grade</label>
//                     <select
//                       className="form-select"
//                       id="certificateGrade"
//                       value={modalData.certificateGrade}
//                       onChange={(e) => setModalData(prev => ({ ...prev, certificateGrade: e.target.value }))}
//                     >
//                       <option value="">Select Grade</option>
//                       <option value="A+">A+</option>
//                       <option value="A">A</option>
//                       <option value="B+">B+</option>
//                       <option value="B">B</option>
//                       <option value="C">C</option>
//                       <option value="Excellent">Excellent</option>
//                       <option value="Good">Good</option>
//                       <option value="Satisfactory">Satisfactory</option>
//                     </select>
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="awardedDate" className="form-label">Awarded Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       id="awardedDate"
//                       value={modalData.awardedDate}
//                       onChange={(e) => setModalData(prev => ({ ...prev, awardedDate: e.target.value }))}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSubmit}
//                 >
//                   Save & Continue
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default StudentCertificatePage;
// import React, { useState, useEffect } from 'react';

// const StudentCertificatePage = () => {
//   const [students, setStudents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [certificatePreview, setCertificatePreview] = useState(null);
//   const [generatingCertificate, setGeneratingCertificate] = useState(false);
  
//   // Modal states
//   const [showModal, setShowModal] = useState(false);
//   const [currentStudent, setCurrentStudent] = useState(null);
//   const [modalData, setModalData] = useState({
//     certificateGrade: '',
//     awardedDate: ''
//   });
//   const [actionType, setActionType] = useState(''); // 'preview' or 'download'

//   useEffect(() => {
//     fetchStudents();
//   }, []);

//   const fetchStudents = async () => {
//     try {
//       const response = await fetch('/api/new/registrations');
//       const data = await response.json();
//       setStudents(data);
//       setLoading(false);
//     } catch (err) {
//       setError('Failed to fetch student data');
//       setLoading(false);
//     }
//   };

//   const checkCertificateDetails = (student, action) => {
//     if (!student.awardedDate || !student.certificateGrade) {
//       // Show modal to enter details
//       setCurrentStudent(student);
//       setActionType(action);
//       setModalData({
//         certificateGrade: student.certificateGrade || '',
//         awardedDate: student.awardedDate ? new Date(student.awardedDate).toISOString().split('T')[0] : ''
//       });
//       setShowModal(true);
//     } else {
//       // Proceed with action
//       if (action === 'preview') {
//         generateCertificate(student);
//       } else if (action === 'download') {
//         downloadCertificate(student);
//       }
//     }
//   };

//   const handleModalSubmit = async () => {
//     try {
//       if (!modalData.certificateGrade || !modalData.awardedDate) {
//         alert('Please fill in both fields');
//         return;
//       }

//       // Update certificate details in database
//       const response = await fetch(`/api/student/certificate/${currentStudent.regid}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           certificateGrade: modalData.certificateGrade,
//           awardedDate: modalData.awardedDate
//         })
//       });

//       if (!response.ok) {
//         throw new Error('Failed to update certificate details');
//       }

//       const result = await response.json();
      
//       // Update the student in local state
//       setStudents(prev => prev.map(student => 
//         student.regid === currentStudent.regid 
//           ? { ...student, certificateGrade: modalData.certificateGrade, awardedDate: modalData.awardedDate }
//           : student
//       ));

//       // Close modal
//       setShowModal(false);
      
//       // Proceed with the action
//       const updatedStudent = {
//         ...currentStudent,
//         certificateGrade: modalData.certificateGrade,
//         awardedDate: modalData.awardedDate
//       };

//       if (actionType === 'preview') {
//         generateCertificate(updatedStudent);
//       } else if (actionType === 'download') {
//         downloadCertificate(updatedStudent);
//       }

//     } catch (error) {
//       console.error('Error updating certificate details:', error);
//       alert('Error updating certificate details. Please try again.');
//     }
//   };

//   const loadPDFLib = async () => {
//     if (window.PDFLib) {
//       return window.PDFLib;
//     }
    
//     return new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js';
//       script.onload = () => {
//         if (window.PDFLib) {
//           resolve(window.PDFLib);
//         } else {
//           reject(new Error('PDF-lib failed to load'));
//         }
//       };
//       script.onerror = () => reject(new Error('Failed to load PDF-lib script'));
//       document.head.appendChild(script);
      
//       setTimeout(() => reject(new Error('PDF-lib loading timeout')), 10000);
//     });
//   };

//   const generateCertificate = async (student) => {
//     setGeneratingCertificate(true);
//     try {
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       const response = await fetch('./cert5.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found');
//       }
      
//       const existingPdfBytes = await response.arrayBuffer();
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();

//       // Add text to certificate
//       firstPage.drawText(`${student.fName} ${student.lName}`, {
//         x: width / 2 - 100,
//         y: height - 300,
//         size: 24,
//         color: rgb(0, 0, 0),
//       });

//       if (student.guardianName) {
//         firstPage.drawText(`S/O ${student.guardianName}`, {
//           x: width / 2 - 80,
//           y: height - 340,
//           size: 16,
//           color: rgb(0, 0, 0),
//         });
//       }

//       firstPage.drawText(student.courseName || 'Course Name', {
//         x: width / 2 - 100,
//         y: height - 380,
//         size: 18,
//         color: rgb(0, 0, 0),
//       });

//       // Use certificateGrade instead of Grade
//       firstPage.drawText(`Grade: ${student.certificateGrade}`, {
//         x: width / 2 - 60,
//         y: height - 460,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Registration ID: ${student.regid}`, {
//         x: width / 2 - 100,
//         y: height - 490,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       // Use awardedDate
//       const awardedDate = new Date(student.awardedDate).toLocaleDateString();
//       firstPage.drawText(`Date: ${awardedDate}`, {
//         x: width - 200,
//         y: 100,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const pdfBytes = await pdfDoc.save();
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       setCertificatePreview(url);
      
//     } catch (error) {
//       console.error('Error generating certificate:', error);
//       alert('Error generating certificate. Please try again.');
//     } finally {
//       setGeneratingCertificate(false);
//     }
//   };

//   const downloadCertificate = async (student) => {
//     try {
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       const response = await fetch('./cert5.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found');
//       }
      
//       const existingPdfBytes = await response.arrayBuffer();
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();

//       // Same certificate generation logic as preview
//       firstPage.drawText(`${student.fName} ${student.lName}`, {
//         x: width / 2 - 100,
//         y: height - 300,
//         size: 24,
//         color: rgb(0, 0, 0),
//       });

//       if (student.guardianName) {
//         firstPage.drawText(`S/O ${student.guardianName}`, {
//           x: width / 2 - 80,
//           y: height - 340,
//           size: 16,
//           color: rgb(0, 0, 0),
//         });
//       }

//       firstPage.drawText(student.courseName || 'Course Name', {
//         x: width / 2 - 100,
//         y: height - 380,
//         size: 18,
//         color: rgb(0, 0, 0),
//       });

//       // Display subjects in download function too
//       const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
//         ? student.selectedSubjects.map(subject => subject.SubjectName).join(', ')
//         : 'No subjects specified';
      
//       firstPage.drawText(`Software covered: ${subjectNames}`, {
//         x: width / 2 - 120,
//         y: height - 420,
//         size: 14,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Grade: ${student.certificateGrade}`, {
//         x: width / 2 - 60,
//         y: height - 460,
//         size: 16,
//         color: rgb(0, 0, 0),
//       });

//       firstPage.drawText(`Registration ID: ${student.regid}`, {
//         x: width / 2 - 100,
//         y: height - 490,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const awardedDate = new Date(student.awardedDate).toLocaleDateString();
//       firstPage.drawText(`Date: ${awardedDate}`, {
//         x: width - 200,
//         y: 100,
//         size: 12,
//         color: rgb(0, 0, 0),
//       });

//       const pdfBytes = await pdfDoc.save();
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `Certificate_${student.fName}_${student.lName}_${student.regid}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
      
//     } catch (error) {
//       console.error('Error downloading certificate:', error);
//       alert('Error downloading certificate. Please try again.');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
//         <div className="alert alert-danger">
//           <h4>Error!</h4>
//           <p>{error}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '2rem' }}>
//       <div className="row">
//         <div className="col-12">
//           <h1 className="mb-4 text-dark fw-bold">Student Certificates</h1>
//         </div>
//       </div>

//       {/* Students Table */}
//       <div className="row">
//         <div className="col-12">
//           <div className="card shadow-sm">
//             <div className="card-header">
//               <h5 className="card-title mb-0">Students List</h5>
//             </div>
//             <div className="card-body">
//               <div className="table-responsive">
//                 <table className="table table-hover">
//                   <thead className="table-light">
//                     <tr>
//                       <th>Reg ID</th>
//                       <th>Name</th>
//                       <th>Course</th>
//                       <th>Subjects</th>
//                       <th>Grade</th>
//                       <th>Certificate Grade</th>
//                       <th>Awarded Date</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {students.map((student) => (
//                       <tr key={student._id}>
//                         <td>{student.regid}</td>
//                         <td>{student.fName} {student.lName}</td>
//                         <td>{student.courseName}</td>
//                         <td>
//                           <small className="text-muted">
//                             {student.selectedSubjects && student.selectedSubjects.length > 0 
//                               ? student.selectedSubjects.map(subject => subject.SubjectName).join(', ')
//                               : 'No subjects'
//                             }
//                           </small>
//                         </td>
//                         <td>
//                           <span className={`badge ${
//                             student.Grade === 'Excellent' ? 'bg-success' :
//                             student.Grade === 'Good' ? 'bg-primary' :
//                             'bg-warning text-dark'
//                           }`}>
//                             {student.Grade}
//                           </span>
//                         </td>
//                         <td>
//                           {student.certificateGrade ? (
//                             <span className="badge bg-info">{student.certificateGrade}</span>
//                           ) : (
//                             <span className="badge bg-secondary">Not Set</span>
//                           )}
//                         </td>
//                         <td>
//                           {student.awardedDate ? 
//                             new Date(student.awardedDate).toLocaleDateString() : 
//                             <span className="text-muted">Not Set</span>
//                           }
//                         </td>
//                         <td>
//                           <button
//                             className="btn btn-sm btn-outline-primary me-2"
//                             onClick={() => checkCertificateDetails(student, 'preview')}
//                             disabled={generatingCertificate}
//                           >
//                             {generatingCertificate ? 'Loading...' : 'Preview'}
//                           </button>
//                           <button
//                             className="btn btn-sm btn-success"
//                             onClick={() => checkCertificateDetails(student, 'download')}
//                           >
//                             Download
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Certificate Preview */}
//       {certificatePreview && (
//         <div className="row mt-4">
//           <div className="col-12">
//             <div className="card shadow-sm">
//               <div className="card-header d-flex justify-content-between align-items-center">
//                 <h5 className="card-title mb-0">Certificate Preview</h5>
//                 <button
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={() => setCertificatePreview(null)}
//                 >
//                   Close Preview
//                 </button>
//               </div>
//               <div className="card-body">
//                 <iframe
//                   src={certificatePreview}
//                   width="100%"
//                   height="600px"
//                   style={{ border: '1px solid #dee2e6', borderRadius: '0.375rem' }}
//                   title="Certificate Preview"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modal for Certificate Details */}
//       {showModal && (
//         <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Certificate Details Required</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <p className="mb-3">
//                   Please enter the certificate details for <strong>{currentStudent?.fName} {currentStudent?.lName}</strong>:
//                 </p>
//                 <div>
//                   <div className="mb-3">
//                     <label htmlFor="certificateGrade" className="form-label">Certificate Grade</label>
//                     <select
//                       className="form-select"
//                       id="certificateGrade"
//                       value={modalData.certificateGrade}
//                       onChange={(e) => setModalData(prev => ({ ...prev, certificateGrade: e.target.value }))}
//                     >
//                       <option value="">Select Grade</option>
//                       <option value="A+">A+</option>
//                       <option value="A">A</option>
//                       <option value="B+">B+</option>
//                       <option value="B">B</option>
//                       <option value="C">C</option>
//                       <option value="Excellent">Excellent</option>
//                       <option value="Good">Good</option>
//                       <option value="Satisfactory">Satisfactory</option>
//                     </select>
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="awardedDate" className="form-label">Awarded Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       id="awardedDate"
//                       value={modalData.awardedDate}
//                       onChange={(e) => setModalData(prev => ({ ...prev, awardedDate: e.target.value }))}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSubmit}
//                 >
//                   Save & Continue
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default StudentCertificatePage;
// import React, { useState, useEffect } from 'react';
// import QRCode from 'qrcode';
// const StudentCertificatePage = () => {
//   const [students, setStudents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [certificatePreview, setCertificatePreview] = useState(null);
//   const [generatingCertificate, setGeneratingCertificate] = useState(false);
  
//   // Modal states
//   const [showModal, setShowModal] = useState(false);
//   const [currentStudent, setCurrentStudent] = useState(null);
//   const [modalData, setModalData] = useState({
//     certificateGrade: '',
//     awardedDate: '',
//     trainingcenter:'Mahadevapura, Bengaluru'
//   });
//   const [actionType, setActionType] = useState(''); // 'preview' or 'download'

//   useEffect(() => {
//     fetchStudents();
//   }, []);

//   const fetchStudents = async () => {
//     try {
//       const response = await fetch('/api/new/registrations');
//       const data = await response.json();
//       setStudents(data);
//       setLoading(false);
//     } catch (err) {
//       setError('Failed to fetch student data');
//       setLoading(false);
//     }
//   };

//   const checkCertificateDetails = (student, action) => {
//     if (!student.awardedDate || !student.certificateGrade) {
//       // Show modal to enter details
//       setCurrentStudent(student);
//       setActionType(action);
//       setModalData({
//         certificateGrade: student.certificateGrade || '',
//         awardedDate: student.awardedDate ? new Date(student.awardedDate).toISOString().split('T')[0] : '',
//         trainingcenter:student.trainingcenter || 'Mahadevapura, Bengaluru',
//       });
//       setShowModal(true);
//     } else {
//       // Proceed with action
//       if (action === 'preview') {
//         generateCertificate(student);
//       } else if (action === 'download') {
//         downloadCertificate(student);
//       }
//     }
//   };

//   const handleModalSubmit = async () => {
//     try {
//       if (!modalData.certificateGrade || !modalData.awardedDate) {
//         alert('Please fill in both fields');
//         return;
//       }

//       // Update certificate details in database
//       const response = await fetch(`/api/student/certificate/${currentStudent.regid}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           certificateGrade: modalData.certificateGrade,
//           awardedDate: modalData.awardedDate,
//           trainingcenter:modalData.trainingcenter
//         })
//       });

//       if (!response.ok) {
//         throw new Error('Failed to update certificate details');
//       }

//       const result = await response.json();
      
//       // Update the student in local state
//       setStudents(prev => prev.map(student => 
//         student.regid === currentStudent.regid 
//           ? { ...student, certificateGrade: modalData.certificateGrade, awardedDate: modalData.awardedDate }
//           : student
//       ));

//       // Close modal
//       setShowModal(false);
      
//       // Proceed with the action
//       const updatedStudent = {
//         ...currentStudent,
//         certificateGrade: modalData.certificateGrade,
//         awardedDate: modalData.awardedDate
//       };

//       if (actionType === 'preview') {
//         generateCertificate(updatedStudent);
//       } else if (actionType === 'download') {
//         downloadCertificate(updatedStudent);
//       }

//     } catch (error) {
//       console.error('Error updating certificate details:', error);
//       alert('Error updating certificate details. Please try again.');
//     }
//   };

//   const loadPDFLib = async () => {
//     if (window.PDFLib) {
//       return window.PDFLib;
//     }
    
//     return new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js';
//       script.onload = () => {
//         if (window.PDFLib) {
//           resolve(window.PDFLib);
//         } else {
//           reject(new Error('PDF-lib failed to load'));
//         }
//       };
//       script.onerror = () => reject(new Error('Failed to load PDF-lib script'));
//       document.head.appendChild(script);
      
//       setTimeout(() => reject(new Error('PDF-lib loading timeout')), 10000);
//     });
//   };

//   const formatCourseDuration = (courseIds) => {
//     if (!courseIds || courseIds.length === 0) return 'N/A';
    
//     // Handle if courseIds contains populated course objects
//     if (Array.isArray(courseIds)) {
//       const durations = courseIds.map(course => {
//         // Check if course is populated (object) or just ID (string)
//         if (typeof course === 'object' && course !== null) {
//           if (course.duration && course.duration.value && course.duration.value > 0) {
//             return `${course.duration.value} ${course.duration.unit || 'Months'}`;
//           }
//           return 'Duration not set';
//         }
//         return 'Course not populated';
//       }).filter(duration => duration !== 'Course not populated');
      
//       return durations.length > 0 ? durations.join(', ') : 'N/A';
//     }
    
//     return 'N/A';
//   };

//   const getCourseNames = (courseIds) => {
//     if (!courseIds || courseIds.length === 0) return '';
    
//     if (Array.isArray(courseIds)) {
//       const names = courseIds.map(course => {
//         if (typeof course === 'object' && course !== null && course.CourseName) {
//           return course.CourseName;
//         }
//         return null;
//       }).filter(name => name !== null);
      
//       return names.length > 0 ? names.join(', ') : '';
//     }
    
//     return '';
//   };

 
    

// // const generateCertificate = async (student) => {
// //     setGeneratingCertificate(true);
// //     try {
// //       const PDFLib = await loadPDFLib();
// //       const { PDFDocument, rgb } = PDFLib;
      
// //       const response = await fetch('./certificate6.pdf');
// //       if (!response.ok) {
// //         throw new Error('Certificate template not found');
// //       }
      
// //       const existingPdfBytes = await response.arrayBuffer();
// //       const pdfDoc = await PDFDocument.load(existingPdfBytes);

// //       const pages = pdfDoc.getPages();
// //       const firstPage = pages[0];
// //       const { width, height } = firstPage.getSize();
// //          const qrText = `http://localhost:5176/student/${student.regid}`;
// // const qrDataUrl = await QRCode.toDataURL(qrText);

// // // Embed QR code image into PDF
// // const qrImageBytes = await fetch(qrDataUrl).then(res => res.arrayBuffer());
// // const qrImage = await pdfDoc.embedPng(qrImageBytes);
// // const qrDims = qrImage.scale(0.6);

// // // Draw the QR code on the page (adjust position as needed)
// // firstPage.drawImage(qrImage, {
// //   x: width - 400,
// //   y: 10,
// //   width: qrDims.width,
// //   height: qrDims.height,
// // });
      

// //       // Add text to certificate
// //       firstPage.drawText(`${student.fName} ${student.lName}`, {
// //         x: width / 2 - 120,
// //         y: height - 285,
// //         size: 24,
// //         color: rgb(0, 0, 0),
// //       });

// //       if (student.guardianName) {
// //         firstPage.drawText(` ${student.guardianName}`, {
// //           x: width / 2 + 165,
// //           y: height - 285,
// //           size: 16,
// //           color: rgb(0, 0, 0),
// //         });
// //       }

// //       firstPage.drawText(getCourseNames(student.courseIds) || student.courseName || 'Course Name', {
// //         x: width / 2 - 120,
// //         y: height - 330,
// //         size: 18,
// //         color: rgb(0, 0, 0),
// //       });
// //           const courseDuration = formatCourseDuration(student.courseIds);
// //       firstPage.drawText(` ${courseDuration}`, {
// //         x: width / 2 + 164,
// //         y: height - 330,
// //         size: 18,
// //         color: rgb(0, 0, 0),
// //       });

// //       // Display subjects
// //       const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
// //         ? student.selectedSubjects.map(subject => subject.SubjectName).join(', ')
// //         : 'No subjects specified';
      
// //       firstPage.drawText(`${subjectNames}`, {
// //         x: width / 2 - 120,
// //         y: height - 372,
// //         size: 14,
// //         color: rgb(0, 0, 0),
// //       });
// //  firstPage.drawText((` ${new Date(student.awardedDate).toLocaleDateString('en-GB', {
// //   day: '2-digit',
// //   month: 'short',
// //   year: 'numeric'
// // })}`), {
// //         x: width / 2 + 163,
// //         y: height - 375,
// //         size: 16,
// //         color: rgb(0, 0, 0),
// //       });

// //       // Display course duration
// //      firstPage.drawText(` ${student.trainingcenter}`, {

// //         x: width / 2 - 123,
// //         y: height - 422,
// //         size: 16,
// //         color: rgb(0, 0, 0),
// //       });

// //       // Use certificateGrade instead of Grade
// //       firstPage.drawText(` ${student.certificateGrade}`, {
// //         x: width / 2 +165,
// //         y: height - 422,
// //         size: 16,
// //         color: rgb(0, 0, 0),
// //       });
     
      
// //       firstPage.drawText(`:${student.regid}`, {
// //         x: width / 2 - 75,
// //         y: height - 680,
// //         size: 12,
// //         color: rgb(0, 0, 0),
// //       });

// //       // Use awardedDate
// //       const awardedDate = new Date(student.awardedDate).toLocaleDateString();
// //       firstPage.drawText(`Date: ${awardedDate}`, {
// //         x: width - 200,
// //         y: 100,
// //         size: 12,
// //         color: rgb(0, 0, 0),
// //       });
// // firstPage.drawText(` ${student.regid}`, {
// //         x: width / 2 - 70,
// //         y: height - 493,
// //         size: 12,
// //         color: rgb(0, 0, 0),
// //       });
// //       const pdfBytes = await pdfDoc.save();
// //       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
// //       const url = URL.createObjectURL(blob);
// //       setCertificatePreview(url);
      
// //     } catch (error) {
// //       console.error('Error generating certificate:', error);
// //       alert('Error generating certificate. Please try again.');
// //     } finally {
// //       setGeneratingCertificate(false);
// //     }
// //   };
// const generateCertificate = async (student) => {
//     setGeneratingCertificate(true);
//     try {
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       const response = await fetch('./certificate6.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found');
//       }
      
//       const existingPdfBytes = await response.arrayBuffer();
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);

//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();
      
//       // Load fonts for bold text
//       const helveticaBold = await pdfDoc.embedFont('Helvetica-Bold');
//       const helvetica = await pdfDoc.embedFont('Helvetica');
      
//       // const qrText = `http://localhost:3000/kavana/${student.regid}`;
//  const qrText = `https://excerptech.com/trainings?regid=${student.regid}`;
//       const qrDataUrl = await QRCode.toDataURL(qrText);

//       // Embed QR code image into PDF
//       const qrImageBytes = await fetch(qrDataUrl).then(res => res.arrayBuffer());
//       const qrImage = await pdfDoc.embedPng(qrImageBytes);
//       const qrDims = qrImage.scale(0.6);

//       // Draw the QR code on the page (adjust position as needed)
//       firstPage.drawImage(qrImage, {
//         x: width - 400,
//         y: 10,
//         width: qrDims.width,
//         height: qrDims.height,
//       });

//       // Helper function to convert text to camel case
//       const toCamelCase = (text) => {
//         if (!text) return '';
//         return text.split(' ')
//           .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//           .join(' ');
//       };

//       // 1. Student name - ALL CAPITAL and bold
//       firstPage.drawText(`${student.fName.toUpperCase()} ${student.lName.toUpperCase()}`, {
//         x: width / 2 - 120,
//         y: height - 285,
//         size: 18,
//         color: rgb(0, 0, 0),
//         font: helveticaBold,
//       });

//       // 2. Guardian name - Camel case
//       if (student.guardianName) {
//         firstPage.drawText(` ${toCamelCase(student.guardianName)}`, {
//           x: width / 2 + 165,
//           y: height - 285,
//           size: 16,
//           color: rgb(0, 0, 0),
//           font: helvetica,
//         });
//       }

//       // Course name - Camel case
//       const courseName = getCourseNames(student.courseIds) || student.courseName || 'Course Name';
//       firstPage.drawText(toCamelCase(courseName), {
//         x: width / 2 - 120,
//         y: height - 330,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       const courseDuration = formatCourseDuration(student.courseIds);
//       firstPage.drawText(` ${courseDuration}`, {
//         x: width / 2 + 164,
//         y: height - 330,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       // 3. Software covered/subjects - Camel case
//       const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
//         ? student.selectedSubjects.map(subject => toCamelCase(subject.SubjectName)).join(', ')
//         : 'No Subjects Specified';
      
//       firstPage.drawText(`${subjectNames}`, {
//         x: width / 2 - 120,
//         y: height - 372,
//         size: 14,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       firstPage.drawText((` ${new Date(student.awardedDate).toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric'
//       })}`), {
//         x: width / 2 + 163,
//         y: height - 375,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       // Display training center - Camel case
//       firstPage.drawText(` ${toCamelCase(student.trainingcenter)}`, {
//         x: width / 2 - 123,
//         y: height - 422,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       // Use certificateGrade - Camel case
//       firstPage.drawText(` ${toCamelCase(student.certificateGrade)}`, {
//         x: width / 2 + 165,
//         y: height - 422,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });
     
//       // 4. RegID - Bold
//       firstPage.drawText(`:${student.regid}`, {
//         x: width / 2 - 75,
//         y: height - 680,
//         size: 12,
//         color: rgb(0, 0, 0),
//         font: helveticaBold,
//       });

//       // Use awardedDate
//       // const awardedDate = new Date(student.awardedDate).toLocaleDateString();
//       // firstPage.drawText(`Date: ${awardedDate}`, {
//       //   x: width - 200,
//       //   y: 100,
//       //   size: 12,
//       //   color: rgb(0, 0, 0),
//       //   font: helvetica,
//       // });

//       // RegID - Bold
//       firstPage.drawText(` ${student.regid}`, {
//         x: width / 2 - 70,
//         y: height - 493,
//         size: 12,
//         color: rgb(0, 0, 0),
//         font: helveticaBold,
//       });

//       const pdfBytes = await pdfDoc.save();
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       setCertificatePreview(url);
      
//     } catch (error) {
//       console.error('Error generating certificate:', error);
//       alert('Error generating certificate. Please try again.');
//     } finally {
//       setGeneratingCertificate(false);
//     }
//   };
//   const downloadCertificate = async (student) => {
//     try {
//       // Load PDF-lib
//       const PDFLib = await loadPDFLib();
//       const { PDFDocument, rgb } = PDFLib;
      
//       // Check if template exists
//       const response = await fetch('./certificate6.pdf');
//       if (!response.ok) {
//         throw new Error('Certificate template not found. Please ensure certificate6.pdf is in the public folder.');
//       }
      
//       // Fetch the existing certificate template
//       const existingPdfBytes = await response.arrayBuffer();
      
//       // Load the existing PDF
//       const pdfDoc = await PDFDocument.load(existingPdfBytes);
//       const pages = pdfDoc.getPages();
//       const firstPage = pages[0];
//       const { width, height } = firstPage.getSize();
// // Load fonts for bold text
//       const helveticaBold = await pdfDoc.embedFont('Helvetica-Bold');
//       const helvetica = await pdfDoc.embedFont('Helvetica');
      
//      const qrText = `https://excerptech.com/trainings?regid=${student.regid}`;
//       const qrDataUrl = await QRCode.toDataURL(qrText);


//       // Embed QR code image into PDF
//       const qrImageBytes = await fetch(qrDataUrl).then(res => res.arrayBuffer());
//       const qrImage = await pdfDoc.embedPng(qrImageBytes);
//       const qrDims = qrImage.scale(0.6);

//       // Draw the QR code on the page (adjust position as needed)
//       firstPage.drawImage(qrImage, {
//         x: width - 400,
//         y: 10,
//         width: qrDims.width,
//         height: qrDims.height,
//       });

//       // Helper function to convert text to camel case
//       const toCamelCase = (text) => {
//         if (!text) return '';
//         return text.split(' ')
//           .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//           .join(' ');
//       };

//       // 1. Student name - ALL CAPITAL and bold
//       firstPage.drawText(`${student.fName.toUpperCase()} ${student.lName.toUpperCase()}`, {
//         x: width / 2 - 120,
//         y: height - 285,
//         size: 18,
//         color: rgb(0, 0, 0),
//         font: helveticaBold,
//       });

//       // 2. Guardian name - Camel case
//       if (student.guardianName) {
//         firstPage.drawText(` ${toCamelCase(student.guardianName)}`, {
//           x: width / 2 + 165,
//           y: height - 285,
//           size: 16,
//           color: rgb(0, 0, 0),
//           font: helvetica,
//         });
//       }

//       // Course name - Camel case
//       const courseName = getCourseNames(student.courseIds) || student.courseName || 'Course Name';
//       firstPage.drawText(toCamelCase(courseName), {
//         x: width / 2 - 120,
//         y: height - 330,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       const courseDuration = formatCourseDuration(student.courseIds);
//       firstPage.drawText(` ${courseDuration}`, {
//         x: width / 2 + 164,
//         y: height - 330,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       // 3. Software covered/subjects - Camel case
//       const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
//         ? student.selectedSubjects.map(subject => toCamelCase(subject.SubjectName)).join(', ')
//         : 'No Subjects Specified';
      
//       firstPage.drawText(`${subjectNames}`, {
//         x: width / 2 - 120,
//         y: height - 372,
//         size: 14,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       firstPage.drawText((` ${new Date(student.awardedDate).toLocaleDateString('en-GB', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric'
//       })}`), {
//         x: width / 2 + 163,
//         y: height - 375,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       // Display training center - Camel case
//       firstPage.drawText(` ${toCamelCase(student.trainingcenter)}`, {
//         x: width / 2 - 123,
//         y: height - 422,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });

//       // Use certificateGrade - Camel case
//       firstPage.drawText(` ${toCamelCase(student.certificateGrade)}`, {
//         x: width / 2 + 165,
//         y: height - 422,
//         size: 16,
//         color: rgb(0, 0, 0),
//         font: helvetica,
//       });
     
//       // 4. RegID - Bold
//       firstPage.drawText(`:${student.regid}`, {
//         x: width / 2 - 75,
//         y: height - 680,
//         size: 12,
//         color: rgb(0, 0, 0),
//         font: helveticaBold,
//       });

//       // Use awardedDate
//       // const awardedDate = new Date(student.awardedDate).toLocaleDateString();
//       // firstPage.drawText(`Date: ${awardedDate}`, {
//       //   x: width - 200,
//       //   y: 100,
//       //   size: 12,
//       //   color: rgb(0, 0, 0),
//       //   font: helvetica,
//       // });

//       // RegID - Bold
//       firstPage.drawText(` ${student.regid}`, {
//         x: width / 2 - 70,
//         y: height - 493,
//         size: 12,
//         color: rgb(0, 0, 0),
//         font: helveticaBold,
//       });

//       // Generate PDF bytes
//       const pdfBytes = await pdfDoc.save();
      
//       // Create download link
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `Certificate_${student.fName}_${student.lName}_${student.regid}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
      
//     } catch (error) {
//       console.error('Error downloading certificate:', error);
//       alert('Error downloading certificate. Please try again.');
//     }
//   };
//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
//         <div className="alert alert-danger">
//           <h4>Error!</h4>
//           <p>{error}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container" >
//       <div className="row">
//         <div className="col-12">
//           <h1 className="mb-4 text-dark fw-bold">Student Certificates</h1>
//         </div>
//       </div>

//       {/* Students Table */}
//       <div className='container'>
    
//         <div className="col-12">
//           <div className="card ">
//             <div className="card-header">
//               <h5 className="card-title mb-0">Students List</h5>
//             </div>
//             <div className="card-body">
//               <div className="table-responsive">
//                 <table className="table table-hover">
//                   <thead className="table-light">
//                     <tr>
//                       <th>Reg ID</th>
//                       <th>Name</th>
//                       <th>Course</th>
//                       <th>Duration</th>
//                       <th>Subjects</th>
//                       <th>Grade</th>
//                       <th>Certificate Grade</th>
//                       <th>Awarded Date</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {students.map((student) => (
//                       <tr key={student._id}>
//                         <td>{student.regid}</td>
//                         <td>{student.fName} {student.lName}</td>
//                         <td>{getCourseNames(student.courseIds) || student.courseName}</td>
//                         <td>
//                           <small className="text-muted">
//                             {formatCourseDuration(student.courseIds)}
//                           </small>
//                           {/* Debug info - remove in production */}
//                           {/* {process.env.NODE_ENV === 'development' && (
//                             <div style={{fontSize: '10px', color: 'red'}}>
//                               Debug: {JSON.stringify(student.courseIds?.length || 0)} courses
//                             </div>
//                           )} */}
//                         </td>
//                         <td>
//                           <small className="text-muted">
//                             {student.selectedSubjects && student.selectedSubjects.length > 0 
//                               ? student.selectedSubjects.map(subject => subject.SubjectName).join(', ')
//                               : 'No subjects'
//                             }
//                           </small>
//                         </td>
//                         <td>
//                           <span className={`badge ${
//                             student.Grade === 'Excellent' ? 'bg-success' :
//                             student.Grade === 'Good' ? 'bg-primary' :
//                             'bg-warning text-dark'
//                           }`}>
//                             {student.Grade}
//                           </span>
//                         </td>
//                         <td>
//                           {student.certificateGrade ? (
//                             <span className="badge bg-info">{student.certificateGrade}</span>
//                           ) : (
//                             <span className="badge bg-secondary">Not Set</span>
//                           )}
//                         </td>
//                         <td>
//                           {student.awardedDate ? 
//                             new Date(student.awardedDate).toLocaleDateString() : 
//                             <span className="text-muted">Not Set</span>
//                           }
//                         </td>
//                         <td>
//                           <button
//                             className="btn btn-sm btn-outline-primary me-2"
//                             onClick={() => checkCertificateDetails(student, 'preview')}
//                             disabled={generatingCertificate}
//                           >
//                             {generatingCertificate ? 'Loading...' : 'Preview'}
//                           </button>
//                           <button
//                             className="btn btn-sm btn-success"
//                             onClick={() => checkCertificateDetails(student, 'download')}
//                           >
//                             Download
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
      
//       </div>
//       </div>

//       {/* Certificate Preview */}
//     {/* Certificate Preview Modal */}
//       {certificatePreview && (
//         <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//           <div className="modal-dialog modal-xl modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Certificate Preview</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setCertificatePreview(null)}
//                 ></button>
//               </div>
//               <div className="modal-body p-0">
//                 <iframe
//                   src={certificatePreview}
//                   width="100%"
//                   height="600px"
//                   style={{ border: 'none' }}
//                   title="Certificate Preview"
//                 />
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => setCertificatePreview(null)}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modal for Certificate Details */}
//       {showModal && (
//         <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Certificate Details Required</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() => setShowModal(false)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <p className="mb-3">
//                   Please enter the certificate details for <strong>{currentStudent?.fName} {currentStudent?.lName}</strong>:
//                 </p>
//                 <div>
//                   <div className="mb-3">
//                     <label htmlFor="certificateGrade" className="form-label">Certificate Grade</label>
//                     <select
//                       className="form-select"
//                       id="certificateGrade"
//                       value={modalData.certificateGrade}
//                       onChange={(e) => setModalData(prev => ({ ...prev, certificateGrade: e.target.value }))}
//                     >
//                       <option value="">Select Grade</option>
//                       <option value="A+">A+</option>
//                       <option value="A">A</option>
//                       <option value="B+">B+</option>
//                       <option value="B">B</option>
//                       <option value="C">C</option>
//                       <option value="Excellent">Excellent</option>
//                       <option value="Good">Good</option>
//                       <option value="Satisfactory">Satisfactory</option>
//                     </select>
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="awardedDate" className="form-label">Awarded Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       id="awardedDate"
//                       value={modalData.awardedDate}
//                       onChange={(e) => setModalData(prev => ({ ...prev, awardedDate: e.target.value }))}
//                     />
//                   </div>
//                    <div className="mb-3">
//                     <label htmlFor="trainingcenter" className="form-label">Training Center</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="trainingcenter"
//                       value={modalData.trainingcenter}
//                       onChange={(e) => setModalData(prev => ({ ...prev, trainingcenter: e.target.value }))}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={() => setShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSubmit}
//                 >
//                   Save & Continue
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default StudentCertificatePage;

import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const StudentCertificatePage = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [certificatePreview, setCertificatePreview] = useState(null);
  const [generatingCertificate, setGeneratingCertificate] = useState(false);
  
  // Search and pagination states
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [studentsPerPage] = useState(10);
  
  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [currentStudent, setCurrentStudent] = useState(null);
  const [modalData, setModalData] = useState({
    certificateGrade: '',
    awardedDate: '',
    trainingcenter: 'Mahadevapura, Bengaluru'
  });
  const [actionType, setActionType] = useState('');

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const response = await fetch('/api/new/registrations');
      const data = await response.json();
      setStudents(data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch student data');
      setLoading(false);
    }
  };

  
  const getCourseNames = (courseIds) => {
    if (!courseIds || courseIds.length === 0) return '';
    
    if (Array.isArray(courseIds)) {
      const names = courseIds.map(course => {
        if (typeof course === 'object' && course !== null && course.CourseName) {
          return course.CourseName;
        }
        return null;
      }).filter(name => name !== null);
      
      return names.length > 0 ? names.join(', ') : '';
    }
    
    return '';
  };
    const formatCourseDuration = (courseIds) => {
    if (!courseIds || courseIds.length === 0) return 'N/A';
    
    if (Array.isArray(courseIds)) {
      const durations = courseIds.map(course => {
        if (typeof course === 'object' && course !== null) {
          if (course.duration && course.duration.value && course.duration.value > 0) {
            return `${course.duration.value} ${course.duration.unit || 'Months'}`;
          }
          return 'Duration not set';
        }
        return 'Course not populated';
      }).filter(duration => duration !== 'Course not populated');
      
      return durations.length > 0 ? durations.join(', ') : 'N/A';
    }
    
    return 'N/A';
  };
  // Filter students based on search term
  const filteredStudents = students.filter(student => {
    const searchLower = searchTerm.toLowerCase();
    const courseName = getCourseNames(student.courseIds) || student.courseName || '';
    const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
      ? student.selectedSubjects.map(subject => subject.SubjectName).join(', ')
      : '';
    const duration = formatCourseDuration(student.courseIds);
    const awardedDate = student.awardedDate ? new Date(student.awardedDate).toLocaleDateString() : '';
    
    return (
      student.regid?.toLowerCase().includes(searchLower) ||
      `${student.fName} ${student.lName}`.toLowerCase().includes(searchLower) ||
      courseName.toLowerCase().includes(searchLower) ||
      duration.toLowerCase().includes(searchLower) ||
      subjectNames.toLowerCase().includes(searchLower) ||
      student.Grade?.toLowerCase().includes(searchLower) ||
      student.certificateGrade?.toLowerCase().includes(searchLower) ||
      awardedDate.includes(searchLower) ||
      student.guardianName?.toLowerCase().includes(searchLower)
    );
  });

  // Pagination calculations
  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = filteredStudents.slice(indexOfFirstStudent, indexOfLastStudent);
  const totalPages = Math.ceil(filteredStudents.length / studentsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const checkCertificateDetails = (student, action) => {
    if (!student.awardedDate || !student.certificateGrade) {
      setCurrentStudent(student);
      setActionType(action);
      setModalData({
        certificateGrade: student.certificateGrade || '',
        awardedDate: student.awardedDate ? new Date(student.awardedDate).toISOString().split('T')[0] : '',
        trainingcenter: student.trainingcenter || 'Mahadevapura, Bengaluru',
      });
      setShowModal(true);
    } else {
      if (action === 'preview') {
        generateCertificate(student);
      } else if (action === 'download') {
        downloadCertificate(student);
      }
    }
  };

  // const handleModalSubmit = async () => {
  //   try {
  //     if (!modalData.certificateGrade || !modalData.awardedDate) {
  //       alert('Please fill in both fields');
  //       return;
  //     }

  //     const response = await fetch(`http://localhost:8080/api/student/certificate/${currentStudent.regid}`, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         certificateGrade: modalData.certificateGrade,
  //         awardedDate: modalData.awardedDate,
  //         trainingcenter: modalData.trainingcenter
  //       })
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to update certificate details');
  //     }

  //     setStudents(prev => prev.map(student => 
  //       student.regid === currentStudent.regid 
  //         ? { ...student, certificateGrade: modalData.certificateGrade, awardedDate: modalData.awardedDate }
  //         : student
  //     ));

  //     setShowModal(false);
      
  //     const updatedStudent = {
  //       ...currentStudent,
  //       certificateGrade: modalData.certificateGrade,
  //       awardedDate: modalData.awardedDate
  //     };

  //     if (actionType === 'preview') {
  //       generateCertificate(updatedStudent);
  //     } else if (actionType === 'download') {
  //       downloadCertificate(updatedStudent);
  //     }

  //   } catch (error) {
  //     console.error('Error updating certificate details:', error);
  //     alert('Error updating certificate details. Please try again.');
  //   }
  // };
// Frontend fix - Pass regid in request body instead of URL parameter
const handleModalSubmit = async () => {
  try {
    if (!modalData.certificateGrade || !modalData.awardedDate) {
      alert('Please fill in both fields');
      return;
    }

    const response = await fetch(`/api/student/certificate`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        regid: currentStudent.regid, // Pass regid in body instead of URL
        certificateGrade: modalData.certificateGrade,
        awardedDate: modalData.awardedDate,
        trainingcenter: modalData.trainingcenter
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update certificate details');
    }

    setStudents(prev => prev.map(student => 
      student.regid === currentStudent.regid 
        ? { ...student, certificateGrade: modalData.certificateGrade, awardedDate: modalData.awardedDate }
        : student
    ));

    setShowModal(false);
    
    const updatedStudent = {
      ...currentStudent,
      certificateGrade: modalData.certificateGrade,
      awardedDate: modalData.awardedDate
    };

    if (actionType === 'preview') {
      generateCertificate(updatedStudent);
    } else if (actionType === 'download') {
      downloadCertificate(updatedStudent);
    }

  } catch (error) {
    console.error('Error updating certificate details:', error);
    alert('Error updating certificate details. Please try again.');
  }
};

// Backend fix - Update route to accept regid from request body



  const loadPDFLib = async () => {
    if (window.PDFLib) {
      return window.PDFLib;
    }
    
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js';
      script.onload = () => {
        if (window.PDFLib) {
          resolve(window.PDFLib);
        } else {
          reject(new Error('PDF-lib failed to load'));
        }
      };
      script.onerror = () => reject(new Error('Failed to load PDF-lib script'));
      document.head.appendChild(script);
      
      setTimeout(() => reject(new Error('PDF-lib loading timeout')), 10000);
    });
  };




  const generateCertificate = async (student) => {
    setGeneratingCertificate(true);
    try {
      const PDFLib = await loadPDFLib();
      const { PDFDocument, rgb } = PDFLib;
      
      const response = await fetch('./certificate6.pdf');
      if (!response.ok) {
        throw new Error('Certificate template not found');
      }
      
      const existingPdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
      
      const helveticaBold = await pdfDoc.embedFont('Helvetica-Bold');
      const helvetica = await pdfDoc.embedFont('Helvetica');
      
      console.log('Original student.regid:', student.regid);
    
    // Use hash instead of query parameter to avoid URL parsing issues
    const qrText = `https://excerptech.com/trainings#${student.regid}`;
   

      const qrDataUrl = await QRCode.toDataURL(qrText);

      const qrImageBytes = await fetch(qrDataUrl).then(res => res.arrayBuffer());
      const qrImage = await pdfDoc.embedPng(qrImageBytes);
      const qrDims = qrImage.scale(0.5);

      firstPage.drawImage(qrImage, {
        x: width - 380,
        y: 10,
        width: qrDims.width,
        height: qrDims.height,
      });

      const toCamelCase = (text) => {
        if (!text) return '';
        return text.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      };

      firstPage.drawText(`${student.fName.toUpperCase()} ${student.lName.toUpperCase()}`, {
        x: width / 2 - 205,
        y: height - 285,
        size: 18,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });

      if (student.guardianName) {
        firstPage.drawText(` ${toCamelCase(student.guardianName)}`, {
          x: width / 2 + 130,
          y: height - 285,
          size: 16,
          color: rgb(0, 0, 0),
          font: helvetica,
        });
      }

      const courseName = getCourseNames(student.courseIds) || student.courseName || 'Course Name';
      firstPage.drawText(toCamelCase(courseName), {
        x: width / 2 - 205,
        y: height - 330,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      const courseDuration = formatCourseDuration(student.courseIds);
      firstPage.drawText(` ${courseDuration}`, {
        x: width / 2 + 130,
        y: height - 330,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
        ? student.selectedSubjects.map(subject => toCamelCase(subject.SubjectName)).join(', ')
        : 'No Subjects Specified';
      
      firstPage.drawText(`${subjectNames}`, {
        x: width / 2 - 205,
        y: height - 375,
        size: 14,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      firstPage.drawText((` ${new Date(student.awardedDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })}`), {
        x: width / 2 + 130,
        y: height - 375,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      firstPage.drawText(` ${toCamelCase(student.trainingcenter)}`, {
        x: width / 2 - 210,
        y: height - 422,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      firstPage.drawText(` ${toCamelCase(student.certificateGrade)}`, {
        x: width / 2 + 130,
        y: height - 422,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });
     
      firstPage.drawText(`:${student.regid}`, {
        x: width / 2 - 75,
        y: height - 680,
        size: 12,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });

      firstPage.drawText(` ${student.regid}`, {
        x: width / 2 - 70,
        y: height - 493,
        size: 12,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setCertificatePreview(url);
      
    } catch (error) {
      console.error('Error generating certificate:', error);
      alert('Error generating certificate. Please try again.');
    } finally {
      setGeneratingCertificate(false);
    }
  };

  const downloadCertificate = async (student) => {
    try {
      const PDFLib = await loadPDFLib();
      const { PDFDocument, rgb } = PDFLib;
      
      const response = await fetch('./certificate6.pdf');
      if (!response.ok) {
        throw new Error('Certificate template not found. Please ensure certificate6.pdf is in the public folder.');
      }
      
      const existingPdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
      
      const helveticaBold = await pdfDoc.embedFont('Helvetica-Bold');
      const helvetica = await pdfDoc.embedFont('Helvetica');
  console.log('Original student.regid:', student.regid);
    
    // Use hash instead of query parameter to avoid URL parsing issues
    const qrText = `https://excerptech.com/trainings#${student.regid}`;
   

     
      const qrDataUrl = await QRCode.toDataURL(qrText);

      const qrImageBytes = await fetch(qrDataUrl).then(res => res.arrayBuffer());
      const qrImage = await pdfDoc.embedPng(qrImageBytes);
      const qrDims = qrImage.scale(0.5);

      firstPage.drawImage(qrImage, {
        x: width - 380,
        y: 10,
        width: qrDims.width,
        height: qrDims.height,
      });

      const toCamelCase = (text) => {
        if (!text) return '';
        return text.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      };

     
      firstPage.drawText(`${student.fName.toUpperCase()} ${student.lName.toUpperCase()}`, {
        x: width / 2 - 205,
        y: height - 285,
        size: 18,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });

      if (student.guardianName) {
        firstPage.drawText(` ${toCamelCase(student.guardianName)}`, {
          x: width / 2 + 130,
          y: height - 285,
          size: 16,
          color: rgb(0, 0, 0),
          font: helvetica,
        });
      }

      const courseName = getCourseNames(student.courseIds) || student.courseName || 'Course Name';
      firstPage.drawText(toCamelCase(courseName), {
        x: width / 2 - 205,
        y: height - 330,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      const courseDuration = formatCourseDuration(student.courseIds);
      firstPage.drawText(` ${courseDuration}`, {
        x: width / 2 + 130,
        y: height - 330,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      const subjectNames = student.selectedSubjects && student.selectedSubjects.length > 0 
        ? student.selectedSubjects.map(subject => toCamelCase(subject.SubjectName)).join(', ')
        : 'No Subjects Specified';
      
      firstPage.drawText(`${subjectNames}`, {
        x: width / 2 - 205,
        y: height - 375,
        size: 14,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      firstPage.drawText((` ${new Date(student.awardedDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })}`), {
        x: width / 2 + 130,
        y: height - 375,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      firstPage.drawText(` ${toCamelCase(student.trainingcenter)}`, {
        x: width / 2 - 210,
        y: height - 422,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });

      firstPage.drawText(` ${toCamelCase(student.certificateGrade)}`, {
        x: width / 2 + 130,
        y: height - 422,
        size: 16,
        color: rgb(0, 0, 0),
        font: helvetica,
      });
     
      firstPage.drawText(`:${student.regid}`, {
        x: width / 2 - 75,
        y: height - 680,
        size: 12,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });

      firstPage.drawText(` ${student.regid}`, {
        x: width / 2 - 70,
        y: height - 493,
        size: 12,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });


      firstPage.drawText(` ${student.regid}`, {
        x: width / 2 - 70,
        y: height - 493,
        size: 12,
        color: rgb(0, 0, 0),
        font: helveticaBold,
      });

      const pdfBytes = await pdfDoc.save();
      
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Certificate_${student.fName}_${student.lName}_${student.regid}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error downloading certificate:', error);
      alert('Error downloading certificate. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <div className="alert alert-danger">
          <h4>Error!</h4>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid px-4" style={{ maxWidth: '100%' }}>
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4 text-dark fw-bold">Student Certificates</h1>
        </div>
      </div>

      {/* Students Table */}

        <div className="col-12">
          <div className="">
            <div className="card-header bg-primary text-white">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <h5 className="card-title mb-0">Students List</h5>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="fas fa-search"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name, reg ID, course, grade..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {/* Search Results Info */}
              <div className="px-3 py-2 bg-light border-bottom">
                <small className="text-muted">
                  Showing {currentStudents.length} of {filteredStudents.length} students
                  {searchTerm && ` (filtered from ${students.length} total)`}
                </small>
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-hover table-striped mb-0">
                  <thead className="table-dark sticky-top">
                    <tr>
                      <th style={{ minWidth: '80px' }}>Reg ID</th>
                      <th style={{ minWidth: '150px' }}>Name</th>
                      <th style={{ minWidth: '150px' }}>Course</th>
                      <th style={{ minWidth: '100px' }}>Duration</th>
                      <th style={{ minWidth: '200px' }}>Subjects</th>
                
                      <th style={{ minWidth: '120px' }}>Certificate Grade</th>
                      <th style={{ minWidth: '120px' }}>Awarded Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentStudents.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          {searchTerm ? 'No students found matching your search.' : 'No students available.'}
                        </td>
                      </tr>
                    ) : (
                      currentStudents.map((student) => (
                        <tr key={student._id}>
                          <td className="fw-semibold">{student.regid}</td>
                          <td>{student.fName} {student.lName}</td>
                          <td>
                            <div className="text-truncate" style={{ maxWidth: '150px' }} title={getCourseNames(student.courseIds) || student.courseName}>
                              {getCourseNames(student.courseIds) || student.courseName}
                            </div>
                          </td>
                          <td>
                            <small className="text-muted">
                              {formatCourseDuration(student.courseIds)}
                            </small>
                          </td>
                          <td>
                            <div className="text-truncate" style={{ maxWidth: '200px' }}>
                              <small className="text-muted">
                                {student.selectedSubjects && student.selectedSubjects.length > 0 
                                  ? student.selectedSubjects.map(subject => subject.SubjectName).join(', ')
                                  : 'No subjects'
                                }
                              </small>
                            </div>
                          </td>
                          
                          <td>
                            {student.certificateGrade ? (
                              <span className="badge bg-info">{student.certificateGrade}</span>
                            ) : (
                              <span className="badge bg-secondary">Not Set</span>
                            )}
                          </td>
                          <td>
                            {student.awardedDate ? 
                              <span className="text-nowrap">{new Date(student.awardedDate).toLocaleDateString()}</span> : 
                              <span className="text-muted">Not Set</span>
                            }
                          </td>
                          <td>
                            <div>
                              <button
                                className="btn"
                                onClick={() => checkCertificateDetails(student, 'preview')}
                                disabled={generatingCertificate}
                                title="Preview Certificate"
                              >
                                {generatingCertificate ? (
                                  <span className="fas fa-eye" role="status"></span>
                                ) : (
                             <i className="fas fa-eye me-1"></i>
                                )}
                              </button>
                              <button
                                className="btn "
                                onClick={() => checkCertificateDetails(student, 'download')}
                                title="Download Certificate"
                              >
                            <i className="fas fa-download me-1"></i> 
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="px-3 py-3 bg-light border-top">
                  <nav aria-label="Students pagination">
                    <ul className="pagination pagination-sm justify-content-center mb-0">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      
                      {[...Array(totalPages)].map((_, index) => {
                        const pageNumber = index + 1;
                        // Show first page, last page, current page and 2 pages around current
                        if (
                          pageNumber === 1 ||
                          pageNumber === totalPages ||
                          (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                        ) {
                          return (
                            <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          );
                        } else if (
                          pageNumber === currentPage - 2 ||
                          pageNumber === currentPage + 2
                        ) {
                          return (
                            <li key={pageNumber} className="page-item disabled">
                              <span className="page-link">...</span>
                            </li>
                          );
                        }
                        return null;
                      })}
                      
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                  
                  <div className="text-center mt-2">
                    <small className="text-muted">
                      Page {currentPage} of {totalPages} ({filteredStudents.length} total students)
                    </small>
                  </div>
                </div>
              )}
            </div>
          </div>
   
      </div>

      {/* Certificate Preview Modal */}
      {certificatePreview && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Certificate Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setCertificatePreview(null)}
                ></button>
              </div>
              <div className="modal-body p-0">
                <iframe
                  src={certificatePreview}
                  width="100%"
                  height="600px"
                  style={{ border: 'none' }}
                  title="Certificate Preview"
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setCertificatePreview(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Certificate Details */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Certificate Details Required</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-3">
                  Please enter the certificate details for <strong>{currentStudent?.fName} {currentStudent?.lName}</strong>:
                </p>
                <div>
                  <div className="mb-3">
                    <label htmlFor="certificateGrade" className="form-label">Certificate Grade</label>
                    <select
                      className="form-select"
                      id="certificateGrade"
                      value={modalData.certificateGrade}
                      onChange={(e) => setModalData(prev => ({ ...prev, certificateGrade: e.target.value }))}
                    >
                      <option value="">Select Grade</option>
                      <option value="A+">A+</option>
                      <option value="A">A</option>
                      <option value="B+">B+</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="Excellent">Excellent</option>
                      <option value="Good">Good</option>
                      <option value="Satisfactory">Satisfactory</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="awardedDate" className="form-label">Awarded Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="awardedDate"
                      value={modalData.awardedDate}
                      onChange={(e) => setModalData(prev => ({ ...prev, awardedDate: e.target.value }))}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="trainingcenter" className="form-label">Training Center</label>
                    <input
                      type="text"
                      className="form-control"
                      id="trainingcenter"
                      value={modalData.trainingcenter}
                      onChange={(e) => setModalData(prev => ({ ...prev, trainingcenter: e.target.value }))}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSubmit}
                >
                  Save & Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentCertificatePage;